module.exports = __webpack_public_path__ + "static/mis-caderas-mojadas-te-esperan_2012-0e9f5abb1e84b0bbedbf9c4292c374bd.jpg";